import _ from 'lodash';
import Raven from 'raven-js';

const SET_USER = 'SET_USER';
const SET_KEY = 'SET_KEY';
const SET_TYPE = 'SET_TYPE';

const getters = {
  fullName(state) {
    if (state.user) {
      let username = `${state.user.name || ''} ${state.user.surname || ''}`.trim();
      if (username.length === 0) {
        username = state.user.email.trim();
      }
      return username;
    }
    return null;
  },
  getKey(state) {
    return state.key;
  },
  getLoginType(state) {
    return state.type;
  },
};

const actions = {
  setUser({ commit }, user) {
    commit(SET_USER, user);
    Raven.setUserContext({ id: _.get(user, 'id', null) });
  },
  setKey({ commit }, key) {
    commit(SET_KEY, key);
  },
  setLoginType({ commit }, type) {
    commit(SET_TYPE, type);
  },
};

const mutations = {
  [SET_USER](state, user) {
    state.user = user;
  },
  [SET_KEY](state, key) {
    state.key = key;
  },
  [SET_TYPE](state, type) {
    state.type = type;
  },
};

export default {
  namespaced: true,
  state: {
    user: null,
    key: null,
    type: null,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/auth.js